class ConfiguratorSelect {
    constructor(select) {
        this.select = jQuery(select);
        this._events();
    }

    _events() {
        const id = this.select.each((i, item) => {
            const select = jQuery(item);
            const id = select.attr('id');
            const trigger = jQuery(`.js-select-trigger[data-select-id=${id}]`);

            let flag = false;
            if (trigger.length) {
                trigger.on('click', (e) => {
                    e.preventDefault();
                    if (!flag) {
                        select.select2('open');
                    }
                });


                select.on('select2:open', (e) => {
                    trigger.addClass('active');

                });

                select.on('select2:close', (e) => {
                    trigger.removeClass('active');
                    flag = false;

                });
            }
        });
    }

    onChange(cb) {
        if (this.select.length) {
            try {
                this.select.on('change', (e) => {
                    if (typeof cb === "function") {
                        cb(this.select, e.target);
                    }
                })
            } catch (e) {

            }
        }
    }

}

export default ConfiguratorSelect;
